<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='订单详情'">
    <div class="progress-box border-box box clearfix" v-if="(order.order_state==10||order.order_state==12||order.type==2||order.type==3||order.type==4||order.type==5||order.type==6||order.type==7)">
      <div class="flex tc" :class="(order.order_state==10||order.order_state==12)?'curr':''">
        <div class="flex-t">
          <span class="circle"></span>
        </div>
        <div class="flex-b">待支付</div>
      </div>
      <!--拼团票，新增拼团中状态-->
      <div class="flex tc" :class="order.order_state==12&&(order.type==2||order.type==3||order.type==4||order.type==5||order.type==6||order.type==7)?'curr':''" v-if="order.protype==2">
        <div class="flex-t">
          <span class="circle"></span>
        </div>
        <div class="flex-b">拼团中</div>
      </div>

      <div class="flex tc" :class="(order.type==2||order.type==4||order.type==5||order.type==6||order.type==7)?'curr':''">
        <div class="flex-t">
          <span class="circle"></span>
        </div>
        <div class="flex-b">待接单</div>
      </div>
      <div class="flex tc" :class="(order.type==4||order.type==5||order.type==6||order.type==7)?'curr':''">
        <div class="flex-t">
          <span class="circle"></span>
        </div>
        <div class="flex-b" v-if="order.type==5">进行中</div>
        <div class="flex-b" v-else>待使用</div>
      </div>
      <div class="flex tc" :class="(order.type==6||order.type==7)?'curr':''">
        <div class="flex-t">
          <span class="circle"></span>
        </div>
        <div class="flex-b">已完成</div>
      </div>
    </div>

    <div class="desc bgF border-box" :style="{ 'margin-top': (order.order_state==10||order.order_state==12||order.type==2||order.type==3||order.type==4||order.type==5||order.type==6||order.type==7)?'.3rem':0}">
      <div class="state tc" v-if="order.protype==2&&order.order_state==12&&order.type==3">
        <p class="t cor3">拼团中</p>
        <p class="b cor-p" v-if="countTimeTxt===1">超时关闭</p>
        <p class="b cor-p" v-else><font v-if="order.num - order.people>0">还差{{order.num - order.people}}人成团，</font>剩余时间 {{countTimeTxt}}</p>

        <div class="tx-box border-box">
          <span v-for="(item,index) in peoples" :key="item.name">
            <img class="img" :src="item.headimg" alt="">
          </span>
          <span v-for="(item,index) in nopeople" @click="shareShow=1"><img src="../../assets/icon-tx.png" alt=""></span>
        </div>

      </div>
      <div class="state tc" v-else-if="(order.order_state==11||order.order_state==13)&&(order.type==1||order.type==8)">
        <p class="t cor3">已关闭</p>
      </div>
      <div class="state tc" v-else>
        <p class="t cor3" v-if="order.order_state==10">待支付</p>
        <p class="b cor-p" v-if="order.order_state==10">{{countTimeTxt===1?'超时关闭':'剩余时间 '+countTimeTxt+' 订单将自动关闭'}}</p>
        <p class="t cor3" v-if="order.order_state==12&&order.type==2">待接单</p>
        <p class="b cor-p" v-if="order.order_state==12&&order.type==2">等待景区接单并分配讲解员</p>
        <p class="t cor3" v-if="order.order_state==12&&order.type==4">待使用</p>
        <p class="b cor-p" v-if="order.order_state==12&&order.type==4">{{countTimeTxt===1?'已过讲解开始时间':'距离讲解服务开始，剩余时间 '+countTimeTxt}}</p>
        <p class="t cor3" v-if="order.order_state==12&&order.type==5">进行中</p>
        <p class="t cor3" v-if="order.order_state==12&&order.type==6">待评价</p>
        <p class="t cor3" v-if="order.order_state==12&&order.type==7">已完成</p>
        <p class="t cor3" v-if="order.order_state==15">已退款</p>
        <p class="b cor-p" v-if="order.type==9">景区暂无讲解员资源</p>
      </div>

      <div class="info">
        <div class="box">
          <div class="tit cor6">订单编号</div>
          <div class="flex cor3">{{order.ordernum}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">讲解服务</div>
          <div class="flex cor3">{{order.name}} <font v-if="order.protype==2"> ({{order.num}}人团)</font></div>
        </div>
        <div class="box" v-if="order.orderinfo">
          <div class="tit cor6">讲解规格</div>
          <div class="flex cor3">{{JSON.parse(order.orderinfo).msg}}</div>
        </div>
        <div class="box" v-if="order.siteName">
          <div class="tit cor6">讲解线路</div>
          <div class="flex cor-a" @click="routeShow=1">{{order.siteName}} >></div>
        </div>
        <div class="box">
          <div class="tit cor6">集合地点</div>
          <div class="flex cor-a" style="text-decoration: underline;" @click="openMap">{{order.address}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">讲解时间</div>
          <div class="flex cor-p">{{order.time}} {{order.stime}}-{{order.etime}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">下单时间</div>
          <div class="flex cor3">{{order.ordertime}}</div>
        </div>
        <div class="box" v-if="order.protype==1">
          <div class="tit cor6">出行人数</div>
          <div class="flex cor3">{{order.people}}</div>
        </div>
        <div class="box" v-if="order.protype==2">
          <div class="tit cor6">购买数量</div>
          <div class="flex cor3">{{order.buynum}}</div>
        </div>
        <div class="box" v-if="order.etype==1 && order.protype==1">
          <div class="tit cor6">耳机需求</div>
          <div class="flex cor3">{{order.eneed==1?'需要':'不需要'}} <span class="cor-p">（{{order.erprice>0?'费用：￥'+order.erprice:'免费'}}）</span></div>
        </div>
        <div class="box" v-if="order.fprice>0">
          <div class="tit cor6">预约服务费</div>
          <div class="flex cor-p">￥{{order.fprice}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">订单总价</div>
          <div class="flex cor-p">
            <span class="cor3" v-if="order.jprice>0 && order.fprice>0">￥{{order.jprice}}(讲解费) + ￥{{order.fprice}}(服务费) = </span>
            ￥{{order.totalmoeny}}
          </div>
        </div>
        <div class="box">
          <div class="tit cor6">联系人</div>
          <div class="flex cor3">{{order.username}}</div>
        </div>
        <!--<div class="box" v-if="order.idcard">-->
          <!--<div class="tit cor6">身份证号</div>-->
          <!--<div class="flex cor3">{{order.idcard|setIdcard}}</div>-->
        <!--</div>-->
        <div class="box">
          <div class="tit cor6">联系电话</div>
          <div class="flex cor3">{{order.phone}}</div>
        </div>
        <div class="box" v-if="order.sign==1">
          <div class="tit cor6">签到状态</div>
          <div class="flex cor-p">已签到</div>
        </div>
        <div class="box" v-if="order.signtime">
          <div class="tit cor6">签到时间</div>
          <div class="flex cor3">{{order.signtime}}</div>
        </div>
      </div>
    </div>
    <!--
    <div class="desc bgF border-box mt15" v-if="order.guideId">
      <div class="info">
        <div class="box">
          <div class="tit cor6" style="line-height: 1.36rem;">讲解员</div>
          <div class="img-tx">
            <img class="img" :src="order.guidelogo" alt="">
          </div>
          <div class="flex cor3">
            <div class="guide-name hide">{{order.guidename}}</div>
            <div class="guide-info hide">{{order.guidetag}}</div>
          </div>
        </div>
      </div>
    </div>
    -->

    <div class="comment-box border-box" v-if="order.comments && order.comments.length>0">
      <div class="title clearfix">
        <div class="fl tit-line"><b></b><span>游客评价</span></div>
      </div>
      <div class="comment-item box" v-for="(item,index) in order.comments" :key="item.id">
        <img class="l" v-lazy="item.headimg" alt="">
        <div class="flex r">
          <div class="intro box">
            <div class="flex">
              <div class="hide">{{item.username}}</div>
              <div class="star">
                <template v-for="(star,index) in [1,2,3,4,5]">
                  <img v-if="item.score>=star" src="../../assets/icon-star-curr.png"/>
                  <img v-else  src="../../assets/icon-star.png" />
                </template>
              </div>
            </div>
            <div class="time">{{item.addtime.slice(0,10)}}</div>
          </div>
          <div class="desc1">{{item.content}}</div>
          <div class="comment-img clearfix" v-if="item.img&&(item.img).split(',').length>0">
            <img class="img" :src="ite" alt="" v-for="(ite,ind) in (item.img).split(',')"  @click="seeComImg(ite,(item.img).split(','))">
          </div>
        </div>
      </div>
    </div>

    <div class="desc bgF border-box mt15">
      <div class="info">
        <div class="tit cor3 bold">预约须知</div>
        <div v-html="order.info" id="descinfo"></div>
      </div>
    </div>

    <div class="bot-box bgF border-box" v-if="(order.order_state==10||order.order_state==12)&&(order.type==1||order.type==3||order.type==6||order.type==7) || ((order.type==2||order.type==4)&&order.protype==1)">
      <div class="btn line" :class="[(order.type==2||order.type==4)?'tc':'fl',(order.order_state==12&&order.type==4&&order.isSign&&!order.sign)?'fl':'']" @click="cancelOrderFun()" v-if="order.protype==2&&order.order_state==12&&order.type==3">取消订单</div>
      <div class="btn line" :class="[(order.type==2||order.type==4)?'tc':'fl',(order.order_state==12&&order.type==4&&order.isSign&&!order.sign)?'fl':'']" @click="cancelOrderFun()" v-if="order.protype==1&&order.order_state==12&&(order.type==2||order.type==4)">取消订单</div>
      <div class="fl btn line" @click="cancelPayFun()" v-if="order.order_state==10">取消支付</div>
      <div class="fr btn linear" @click="getPayMoneyFun()" v-if="order.order_state==10">支付</div>
      <div class="fr btn linear" @click="signOrder()" v-if="order.order_state==12&&order.type==4&&order.isSign">签到</div>

      <div class="fr btn linear" v-if="order.protype==2&&order.order_state==12&&order.type==3" @click="shareShow=1">邀请好友</div>
      <div class="fl btn line" @click="rewardShow=1" v-if="order.order_state==12&&(order.type==6||order.type==7)">打赏</div>
      <div class="fl btn line" @click="toPiao(order.ispiao,order.piaotype)" v-if="order.protype==1&&order.order_state==12&&(order.type==6||order.type==7)">{{order.ispiao==1?'发票详情':'申请开票'}}</div>
      <div class="fr btn linear" @click="toComment" v-if="order.order_state==12&&(order.type==6||order.type==7)">评价</div>
    </div>

    <!--打赏弹窗-->
    <div class="alert-reward tc" v-if="rewardShow==1">
      <div class="mask" @click="rewardShow=0"></div>
      <div class="alert-con">
        <p class="alert-title">讲的非常好！</p>
        <p class="alert-sub" v-if="dsTotal>0">共有{{dsTotal}}人打赏，支持鼓励导游！</p>
        <p class="alert-sub" v-else>打赏一下，支持鼓励导游！</p>
        <div class="img-box clearfix">
          <img class="img" v-lazy="item.headimg" alt="" v-for="(item,index) in dslist" :key="index">
          <img class="icon-dian" src="../../assets/icon-dian.png" alt="" v-if="dslist.length>=15">
        </div>
        <div class="reward-money clearfix">
          <span @click="clickFixedNum(10)" :data-price="10" class="hide" v-bind:class="{ curr:10==currentPrice}">10元</span>
          <span @click="clickFixedNum(8)" :data-price="8" class="hide" v-bind:class="{ curr:8==currentPrice}">8元</span>
          <span @click="clickFixedNum(5)" :data-price="5" class="hide" v-bind:class="{ curr:5==currentPrice}">5元</span>
          <span @click="clickFixedNum(2)" :data-price="2" class="hide" v-bind:class="{ curr:2==currentPrice}">2元</span>
        </div>
        <div class="reward-money-input border-box clearfix">
          <span class="fl">打赏金额：</span>
          <input class="fl" placeholder='土豪请随意' maxlength="5" type="number" @keydown="handleInput2" number v-model.number="inputPrice" v-on:input="inputNum(inputPrice)"/>
        </div>
        <div class="btn-box">
          <div class="fl btn" @click="rewardShow=0" style="margin-left: 0;">我不打赏</div>
          <div class="fr btn linear" @click="dsOrder">打赏{{currentPrice}}元</div>
        </div>
      </div>
    </div>

    <div class="alert-box alert-share" v-if="shareShow==1">
      <div class="mask" @click="shareShow=0"></div>
      <img src="../../assets/icon-share.png" alt="">
    </div>

    <div class="alert-box alert-route" v-if="routeShow==1">
      <div class="mask" @click="routeShow=0"></div>
      <div class="alert-con curr">
        <img class="close" src="../../assets/icon-close.png" alt="" @click="routeShow=0">
        <p class="tit font34 bold cor3">线路详情</p>
        <div class="route-box">
          <div class="route-info border-box">
            <div class="title clearfix">
              <div class="fl name hide">{{routeDesc.title}}</div>
              <div class="fl label" v-if="routeDesc.label">{{routeDesc.label}}</div>
            </div>
            <div class="desc">
              <div class="item box">
                <img src="../../assets/icon-time.png" alt="">
                <div class="name">讲解时间：</div>
                <div class="r hide">{{routeDesc.time}}</div>
              </div>
              <div class="item box">
                <img src="../../assets/icon-dw.png" alt="">
                <div class="name">线路包含：</div>
                <div class="r hide">{{routeDesc.children.length}}个展馆</div>
              </div>
              <div class="item box">
                <img src="../../assets/icon-piao.png" alt="">
                <div class="name">适用票种：</div>
                <div class="r hide" v-if="routeDesc.type==1">VIP套票</div>
                <div class="r hide" v-if="routeDesc.type==2">拼团票</div>
                <div class="r hide" v-if="routeDesc.type==3">VIP套票、拼团票</div>
              </div>
            </div>
            <div class="route-line" v-if="routeDesc.children && routeDesc.children.length>0">
              <div class="item" v-for="(item,index) in routeDesc.children" :key="item.name">
                <div class="name box">
                  <div class="l">{{index+1}}</div>
                  <div class="flex r hide">{{item.name}}</div>
                </div>
                <div class="route-img border-box clearfix" :class="(item.logo && item.logo.split(','))?('routeimg'+item.logo.split(',').length):''" v-if="item.logo">
                  <img v-lazy="ite" alt="" :key="ite" v-for="(ite,ind) in (item.logo).split(',')">
                </div>
                <div class="line-txt border-box" v-if="item.info">{{item.info}}</div>
              </div>
            </div>
            <div class="route-tip border-box" v-if="routeDesc.children && routeDesc.children.length>0">*以上线路可能会因人员、时间等原因做相应调整，如有不便敬请谅解。</div>
          </div>
        </div>

      </div>
    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getUserOrderDetail, getUserDSList,getPayCancel, getScenicRotes,userSign,pinOrderDetail} from "@/service/getData";
  import {wxGetPosition, wxOpenMapLocation, creatDSOrder,payMoney} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '', //订单编码
        order: '', //订单详情
        dslist: '', //此订单的打赏列表
        dsTotal: 0, //打赏总数

        peoples: [], //拼团数据
        nopeople: [], //缺的人数数据

        currentPrice:5,//选项卡
        inputPrice:'',//input框值,
        rewardShow: 0,//打赏弹窗 0：隐藏 1：显示
        P400: 0, //系统维护中

        countTimeTxt: '00:00:00',//倒计时
        shareShow:0,//分享弹窗提示 0 ：隐藏 1：显示

        routeShow: 0, //是否显示线路详情
        routeDesc: '', //当前的线路详情
      }
    },
    created(){
      this.userInfo = getStore("userInfo");
      this.getUserOrderDetailFun();

    },
    methods: {
      //获取订单详情数据
      async getUserOrderDetailFun(){
        let res = await getUserOrderDetail({
          ordernum: this.ordernum,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.order = res.data;
          if(!this.scenicId){
            this.scenicId = res.data.scenicId
          }

          var link = '/?vtime='+this.order.time+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey;
          if(this.order.order_state==10 || (this.order.protype==2&&this.order.order_state==12&&this.order.type==3)){
            this.countTime(this.order.mins);
          }else if(this.order.order_state==12&&this.order.type==4){
            this.countTime(this.order.time+' '+this.order.stime,1);
          }
          if(this.order.protype==2&&this.order.order_state==12&&this.order.type==3){
            link = '/order-share?ordernum='+this.ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey;

            this.pinOrderDetailFun();
          }

          if(this.bjDate(this.order.time+' '+this.order.stime)){
            this.order.isSign = true;
          }else {
            this.order.isSign = false;
          }

          this.getUserDSListFun();

          if(this.order.siteId){
            this.getScenicRotesFun();
          }

          let title = res.data.name + '| 导游预约';
          let desc = '欢迎使用导游预约服务系统';
//          wxShareme(title, desc, '', link);


          function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu');
          }

          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
          } else {
            onBridgeReady();
          }


        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取订单详情数据
      async pinOrderDetailFun(){
        let res = await pinOrderDetail({
          ordernum: this.ordernum,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          var peoples = res.data.peoples, arr = [];
          if(peoples && peoples.length>0){
            for(var i=0; i<peoples.length; i++){
              var item = peoples[i];
              if(item.buynum > 1){
                for(var j=0; j<item.buynum; j++){
                  arr.push(item)
                }
              }else {
                arr.push(item)
              }
            }
          }
          this.peoples = arr;

          var num = res.data.num - res.data.people,arr1 = [];
          for(var i=0; i<num; i++){
            arr1.push({})
          }
          this.nopeople = arr1;

        }else {
          this.$toast(res.errmsg);
        }
      },

      //判断当前时间是否在签到时间内
      bjDate(date1) {
        var date = new Date();
        if (date1) {
          if (typeof date1 === 'string') {
            date1 = new Date(date1.replace(/-/g, "/"));
          } else if (typeof date1 === 'number') {
            date1 = new Date(date1);
          }
        }
        var time = date1.getTime() - date.getTime();
        return (time>0 && time<=(7200*1000))?true:false;
      },

      //获取线路信息
      async getScenicRotesFun(){
        let res = await getScenicRotes({
          scenicId: this.order.scenicId
        })
        if (res.errcode == "00000") {
          var routeList = res.data;
          for(var i=0; i<routeList.length; i++){
            if(this.order.siteId==routeList[i].id){
              this.routeDesc = routeList[i];
            }
          }
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取打赏头像列表
      async getUserDSListFun(){
        let res = await getUserDSList({
          guideId: this.order.guideId,
          pageNum: 1,
          pageSize: 15,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.dslist = res.data;
          this.dsTotal = res.total;
        }else {
          this.$toast(res.errmsg);
        }
      },

      //打赏订单
      dsOrder: function (){
        if(this.currentPrice<1){
          this.$toast('打赏金额不小于1元');
        } else if(this.currentPrice>2000){
          this.$toast('打赏金额不大于2000元');
        } else {
          var obj = {
            openid: this.userInfo.openid,
            guideId: this.order.guideId,
            money: this.currentPrice,
            ordernum: this.ordernum
          };
          var self = this;
          creatDSOrder(self,obj,function(data){
            if(data){
              self.clickFixedNum(2);
              self.rewardShow=0;
            }
          });
        }

      },

      //取消支付
      cancelPayFun: function (){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要取消支付吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.getPayCancelFun()
          }
        }).catch(function(res){
          if(res == 'success') {
            self.getPayCancelFun()
          }
        })
      },
      //取消支付
      async getPayCancelFun(ind){
        let res = await getPayCancel({
          ordernum: this.ordernum
        });
        if(res.errcode == "00000"){
          this.order.type=8;
          this.order.order_state=11;
          this.$toast("取消成功")
        }else{
          this.$toast(res.errmsg)
        }
      },

      //对待支付订单重新发起支付
      getPayMoneyFun(){
        var self = this;
        payMoney(self,this.ordernum,function(data){
          if(data){
            self.order.type=2;
            self.order.order_state=12;
          }
        })
      },

      //签到
      signOrder: function (){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要签到此订单吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.userSignFun()
          }
        }).catch(function(res){
          if(res == 'success') {
            self.userSignFun()
          }
        })
      },
      //确定签到
      async userSignFun(){
        let res = await userSign({
          ordernum: this.order.ordernum
        });
        if(res.errcode == "00000"){
          this.getUserOrderDetailFun();

          this.$toast("签到成功")
        }else{
          this.$toast(res.errmsg)
        }
      },

      //取消订单
      cancelOrderFun: function (){
        this.$router.push({
          path: `/order-refund?${'ordernum='+ this.ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //倒计时
      countTime: function(etime, type) {
        //获取当前时间
        var date = new Date();
        var ntime = date.getTime();

        var str = etime;
        if(type==1){
          if (etime) {
            if (typeof etime === 'string') {
              str = new Date(etime.replace(/-/g, "/"));
            } else if (typeof etime === 'number') {
              str = new Date(etime);
            }
          }
          etime = (new Date(str)).getTime();
        }

        //时间差
        var leftTime = etime-ntime;


        if(leftTime <= 0){  //时间已过
          this.countTimeTxt = 1;
        }else {
          //定义变量 d,h,m,s保存倒计时的时间
          var d,h,m,s;
          if (leftTime>=0) {
            d = Math.floor(leftTime/1000/60/60/24);
            h = Math.floor(leftTime/1000/60/60%24);
            m = Math.floor(leftTime/1000/60%60);
            s = Math.floor(leftTime/1000%60);
            h = h>9?h:'0'+h;
            m = m>9?m:'0'+m;
            s = s>9?s:'0'+s;
          }

          var txt = '';
          if(d>0){
            txt = d+"天 "+h+":"+m+":"+s;
          }else {
            txt = h+":"+m+":"+s;
          }
          this.countTimeTxt = txt;

          //递归每秒调用countTime方法，显示动态时间效果
          var self = this;
          setTimeout(function(){
            self.countTime(etime)
          },1000);
        }

      },

      // 通过正则过滤小数点后两位
      handleInput2(e) {
        e.target.value = e.target.value.replace(/[^\d]/g,'');
      },
      //选择打赏金额
      clickFixedNum(item){
        this.currentPrice=item;
        this.inputPrice = ''
      },
      //输入打赏金额
      inputNum(inputPrice){
        this.currentPrice = inputPrice;
        if(inputPrice==''||inputPrice==undefined){
          this.currentPrice = 10
        }
      },
      //跳转至评论页面
      toComment:function(){
        this.$router.push({
          path: `/comment?${'ordernum='+ this.ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      //跳转到发票页面
      toPiao:function (ispiao,piaotype){
        this.$router.push({
          path: `/piao?${'ordernum='+ this.ordernum+'&ispiao='+ispiao+'&piaotype='+piaotype+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //地图导航
      openMap: function (){
        wxOpenMapLocation(this.order.lat, this.order.lng, '', this.order.address)
      },

      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },

    },
    watch: {},
    components: {
        P400
    },
    filters:{
      setIdcard: function (str){
        return (str&&str.length)>=8?(str.substr(0,5)+"*****"+str.substr(-5)):str
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height:100vh;padding: .3rem .3rem 1.2rem;background-color:#f2f2f2}
  .btn{width: 2.4rem;height: .72rem;margin-left:.16rem;font: .34rem/.72rem "Microsoft YaHei";}
  .progress-box{margin-top: .3rem;}
  .progress-box .flex{position:relative;}
  .progress-box .flex:before{content: '';position: absolute;top:.075rem;left:-50%;width: 100%;height: .03rem;background: #d0d0d0;}
  .progress-box .flex:first-child:before{display: none;}
  .progress-box .flex .circle{position: relative;z-index:1;display:block;width: .18rem;height: .18rem;margin: 0 auto;background: #d0d0d0;border-radius: 50%;}
  .progress-box .flex.curr .circle,.progress-box .flex.curr:before{background: #f76260;}
  .progress-box .flex-b{margin-top:.12rem;font-size: .24rem;color: #333;}

  .desc{border-radius: .12rem;padding: 0 .3rem;}
  .state{padding: .5rem 0 .4rem;border-bottom: 1px solid #e3e3e3;}
  .state .t{font: bold .36rem "Microsoft YaHei";}
  .state .b{margin-top: .24rem;font: .26rem "Microsoft YaHei";}
  .info{ padding-top: .3rem;padding-bottom: .2rem; color: #333;}
  .info .box{padding: .2rem 0;font: .28rem/.48rem "Microsoft YaHei";}
  .info .box .tit{width: 1.6rem;}
  .info .box .img-tx{width: 1.2rem;height: 1.36rem;margin-right:.15rem;border-radius: .07rem;overflow: hidden;}
  .info .img-tx img{width: 100%;height: 100%;object-fit: cover;object-position: top;}
  .info .guide-name{font-size: .28rem;color: #333;margin-top: .2rem;}
  .info .guide-info{font-size: .26rem;color: #666;}
  .bot-box{position: fixed;left: 0;bottom: 0;width: 100vw;height: 1.04rem;box-shadow: 0 0 .08rem rgba(0,0,0,.2);}
  .bot-box .btn{width:2rem;margin: .14rem .2rem 0;}
  .bot-box .btn.tc{ margin: .14rem auto 0; }
  .bot-box .btn.tc.fl{margin: .14rem .4rem 0;}
  .alert-share img{position: absolute;top:5%;left:30%;width: 60%;}

  .comment-box{padding:.4rem .3rem;margin: .15rem auto 0;background: #fff;border-radius: .2rem;}
  .comment-item{margin-top: .4rem;}
  .comment-item:first-child{margin-top: .55rem;}
  .comment-item .l{width: .64rem;height: .64rem;margin-right: .14rem;border-radius: 50%;object-fit: cover;object-position: top;}
  .comment-item .intro{height: .64rem;font-size: .28rem;color: #333;}
  .comment-item .star{width: 100%;height: .23rem;margin-top: .06rem;}
  .comment-item .star img{float: left;width: auto;height: .23rem;margin-right: .1rem;}
  .comment-item .time{font-size: .24rem;color: #999;}
  .comment-item .desc1{margin-top:.14rem;font: .28rem/.42rem "Microsoft YaHei";color: #333;}
  .comment-item .comment-img{margin-top: .16rem;}
  .comment-item .img{float:left;width: 32.3%;height:1.8rem;margin-right: 1%;margin-bottom: 1%;border-radius: .2rem;object-fit:cover;overflow: hidden;}

  /*线路详情*/
  .alert-route{position: fixed;top:0;left: 0;z-index:10;width: 100vw;height: 100vh;}
  .alert-route .close{position: absolute;top:.4rem;right: .4rem;width: auto;height: .28rem;}
  .alert-route .mask{position: absolute;left: 0;top:0;width: 100%;height: 100%;background: rgba(0,0,0,.6);}
  .alert-route .alert-con{position: absolute;left: 0;right:0;bottom: -100%;padding-top:.4rem;background: #fff;border-radius: .22rem .22rem 0 0;}
  .alert-route .alert-con.curr{-webkit-animation: alertShow .3s linear;animation: alertShow .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .alert-route .alert-con .tit{text-indent: .4rem;}
  .route-box{ position: relative; max-height: 76vh;padding:0 0 .4rem;margin-top:.3rem;overflow-y: auto;color: #333;}
  @-webkit-keyframes alertShow {from{bottom: -100%;}to{bottom:0;}}
  @keyframes alertShow {from{bottom: -100%;}to{bottom:0;}}

  .route-box .route-info{margin: .1rem;padding: .24rem;background: #fff;border-radius: .2rem;}
  .route-box .title{height: .42rem;}
  .route-box .title .name{max-width:70%;font: .32rem/.42rem "Microsoft YaHei";color: #222;}
  .route-box .title .label{padding: 0 .09rem;margin-left: .08rem;margin-top:.06rem;font: .2rem/.3rem "Microsoft YaHei";color: #fff;background:#fa4f45;border-radius: .06rem;vertical-align: top;}
  .route-box .desc{margin-top: .2rem;}
  .route-box .desc .item{height: .4rem;margin-top: .08rem;}
  .route-box .desc img{width: auto;height: .26rem;vertical-align: top;margin-top: .07rem;margin-right: .12rem;}
  .route-box .desc .name{margin-right:.1rem;font: .26rem/.4rem "Microsoft YaHei";color: #666;}
  .route-box .desc .r{font: .26rem/.4rem "Microsoft YaHei";color: #333;}
  .route-box .route-line{margin-top: .34rem;padding-top:.4rem;padding-right:.3rem;border-top: .02rem solid #e3e3e3;}
  .route-box .route-line .item{position:relative;padding-bottom: .4rem;}
  .route-box .route-line .item:after{content: '';position: absolute;top:0;bottom: 0;left: .17rem;width: .02rem;background: #dcdcdc;}
  .route-box .route-line .item:last-child:after{display: none;}
  .route-box .route-line .name{height: .36rem;color: #222;}
  .route-box .route-line .l{position: relative;z-index: 1;width: .36rem;height: .36rem;margin-right:.12rem;font: bold .2rem/.36rem "Microsoft YaHei";background:#faaf39;border-radius:50%;text-align: center;}
  .route-box .route-line .r{font: .3rem/.36rem "Microsoft YaHei";}
  .route-box .route-img{padding-left: .3rem;}
  .route-box .route-img img{float:left;margin-left:.15rem;width: 30%;height: auto;margin-top: .16rem;border-radius: .1rem;overflow: hidden;}
  .route-box .routeimg1 img{width: 80%;}
  .route-box .routeimg2 img{width: 45%;height: 1.96rem;}
  .route-box .routeimg3 img{width: 30%;}
  .route-box .line-txt{padding-left: .48rem;font: .26rem/.36rem "Microsoft YaHei";color: #666;margin-top: .1rem;}
  .route-box .route-tip{padding-left:.48rem;margin-top:.2rem;font: .26rem/.36rem "Microsoft YaHei";color: #999;}

  /*拼团头像*/
  .tx-box{padding: .17rem 0;}
  .tx-box span{position:relative;display: inline-block;width: .96rem;height: .96rem;margin:.2rem .01rem 0;vertical-align:top;border-radius: 50%;border: 1px solid #e3e3e3;}
  .tx-box span img{width: 100%;height: 100%;object-fit:cover;border-radius: 50%;overflow: hidden;}
  .tx-box span i{position: absolute; left: 50%; bottom: -.14rem; width: .64rem; height: .34rem; margin-left: -.32rem;color:#ffb500;text-align: center;font-style: normal;}
  .tx-box span:first-child i{display:none;}
  .tx-box span:before{content: '';position: absolute;top:0;left: 0;right:0;bottom:0;border: .03rem solid #efefef;border-radius: 50%;}
  .tx-box span:last-child:before{display: none;}
  .tx-box span:first-child:before{content: '';position: absolute;top:0;left: 0;right:0;bottom:0;border: .03rem solid #ffb500;border-radius: 50%;}
  .tx-box span:first-child:after{content: '';position: absolute;left: 50%;bottom:-.1rem;width: .64rem;height: .34rem;margin-left:-.32rem;background: url(../../assets/icon-tz.png) no-repeat center;background-size: 100% auto;}

  #descinfo img{max-width: 100%!important;}
</style>



// WEBPACK FOOTER //
// src/page/home/order-desc.vue